import '../index.css';
import { StaticLandingPageRoutes } from './static-landing-page-routes';

export function StaticLandingApp() {
  return <StaticLandingPageRoutes />;
}